import type { TypographyOptions } from '@mui/material/styles/createTypography'
import { TIPOGRAFIA } from '@/contratos'

const typography: TypographyOptions = {
  fontFamily: TIPOGRAFIA.familiaFallback,
  h1: { fontWeight: TIPOGRAFIA.pesoTitulo },
  h2: { fontWeight: TIPOGRAFIA.pesoTitulo },
  h3: { fontWeight: TIPOGRAFIA.pesoTitulo },
  h4: { fontWeight: TIPOGRAFIA.pesoTitulo },
  h5: { fontWeight: TIPOGRAFIA.pesoTitulo },
}

export default typography
